const locale = {
	MAIL_LIST_ITEM_DEMS_ENABLED: 'Ricezione DEM abilitata',
	MAIL_LIST_ITEM_UNSUBSCRIBED: 'Disiscritto',

	DETAILS_MAILS_FIELD_TITLE: 'Indirizzo email',
	DETAILS_MAILS_FIELD_DESCRIPTION: 'Descrizione',
	DETAILS_MAILS_FIELD_TITLE_INDEX: 'Indirizzo email {index}',
	DETAILS_MAILS_FIELD_DESCRIPTION_INDEX: 'Descrizione {index}',
	DETAILS_MAILS_FIELD_DEFAULT: 'Default',
	DETAILS_MAILS_FIELD_DEMS_ENABLED: 'Abilita ricezione DEM',
	DETAILS_MAILS_FIELD_ITEM: 'Elemento collegato',

	DIALOG_MAILS_ADD: 'Aggiungi Indirizzo Email'
};

export default locale;
